import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaLaptopCode, FaRobot, FaBrain, FaCode, FaDatabase, FaMobileAlt, FaCloud } from 'react-icons/fa';
import "./stem.css";
const TechnologyPage = () => {
  const programCategories = [
    {
      title: "Software Development",
      description: "Comprehensive training in modern programming and development",
      courses: [
        { name: "Full Stack Web Development", description: "Master front-end and back-end technologies (MERN, MEAN stacks)", icon: <FaCode /> },
        { name: "Mobile App Development", description: "Native and cross-platform app development (React Native, Flutter)", icon: <FaMobileAlt /> },
        { name: "Cloud Computing & DevOps", description: "AWS, Azure, Google Cloud, Docker, Kubernetes, CI/CD pipelines", icon: <FaCloud /> },
        { name: "Programming Languages", description: "Python, Java, JavaScript, C++, Go - from fundamentals to advanced", icon: <FaCode /> }
      ]
    },
    {
      title: "AI & Machine Learning",
      description: "Cutting-edge training in artificial intelligence technologies",
      courses: [
        { name: "Machine Learning Engineering", description: "Algorithms, model training, evaluation, and deployment", icon: <FaBrain /> },
        { name: "Deep Learning Specialization", description: "Neural networks, CNN, RNN, transformer models, and applications", icon: <FaBrain /> },
        { name: "AI Application Development", description: "Building intelligent applications with practical industry use cases", icon: <FaRobot /> },
        { name: "Natural Language Processing", description: "Text analytics, sentiment analysis, and language generation", icon: <FaBrain /> }
      ]
    },
    {
      title: "Emerging Technologies",
      description: "Stay ahead with training in the latest tech innovations",
      courses: [
        { name: "Robotics & Automation", description: "Robot programming, sensors, actuators, and control systems", icon: <FaRobot /> },
        { name: "Data Engineering", description: "Big data technologies, ETL pipelines, and data warehousing", icon: <FaDatabase /> },
        { name: "Blockchain Development", description: "Distributed ledger technology, smart contracts, and DApps", icon: <FaCode /> },
        { name: "IoT Systems", description: "Connected device development, IoT architectures, and applications", icon: <FaMobileAlt /> }
      ]
    }
  ];

  return (
    <div className="program-page technology-theme my-5 py-5">
      <div className="program-header">
        <Link to="/" className="text-start">
          <FaArrowLeft /> Back to Programs
        </Link>
        <div className="program-title">
          <FaLaptopCode className="program-header-icon" />
          <h1>Technology Programs</h1>
        </div>
        <p className="program-subtitle">Cutting-edge technology and programming skills for the digital economy</p>
      </div>

      <div className="program-overview">
        <h2>Why Choose Our Technology Coaching?</h2>
        <div className="features-grid">
          <div className="feature-card">
            <h3>Industry-Aligned</h3>
            <p>Curriculum designed with input from tech industry leaders</p>
          </div>
          <div className="feature-card">
            <h3>Project-Based Learning</h3>
            <p>Build a portfolio of real-world projects and applications</p>
          </div>
          <div className="feature-card">
            <h3>Placement Support</h3>
            <p>Resume building, interview preparation, and job placement assistance</p>
          </div>
          <div className="feature-card">
            <h3>Continuous Updates</h3>
            <p>Regular curriculum updates to match industry demands</p>
          </div>
        </div>
      </div>

      <div className="courses-section">
        {programCategories.map((category, index) => (
          <div className="course-category" key={index}>
            <h2>{category.title}</h2>
            <p className="category-description">{category.description}</p>
            
            <div className="courses-grid">
              {category.courses.map((course, courseIndex) => (
                <div className="course-card" key={courseIndex}>
                  <div className="course-icon">{course.icon}</div>
                  <h3>{course.name}</h3>
                  <p>{course.description}</p>
                  <button className="enroll-btn">Learn More</button>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="industry-partners">
        <h2>Our Industry Partners</h2>
        <p>We collaborate with leading tech companies to ensure our curriculum stays current and our students get exposure to real industry problems</p>
        <div className="partners-grid">
          <div className="partner-logo">Tech Corp</div>
          <div className="partner-logo">InnovateX</div>
          <div className="partner-logo">Digital Solutions</div>
          <div className="partner-logo">AI Systems</div>
        </div>
      </div>

      <div className="testimonials-section">
        <h2>Success Stories</h2>
        <div className="testimonials-container">
          <div className="testimonial-card">
            <p>"The AI and ML program helped me transition from a data analyst to an ML engineer role. The hands-on projects and mentorship were invaluable."</p>
            <p className="testimonial-author">- Arjun P., ML Engineer at Tech Solutions</p>
          </div>
          <div className="testimonial-card">
            <p>"I had no coding experience when I joined the Full Stack program. Six months later, I landed a developer role at a startup. The curriculum was challenging but worth it!"</p>
            <p className="testimonial-author">- Neha K., Full Stack Developer</p>
          </div>
        </div>
      </div>

      <div className="cta-section">
        <h2>Ready to Build Your Tech Career?</h2>
        <p>Join our technology programs and develop the skills needed for today's digital economy</p>
        <button className="primary-btn">Schedule a Free Consultation</button>
      </div>
    </div>
  );
};

export default TechnologyPage;